module.exports = __webpack_public_path__ + "img/B.749aa003.png";